var exports = {
  "kL": "PiPOverlay.module__container___Wk1Udm",
  "$I": "PiPOverlay.module__containerResizing___Wk1Udm",
  "n_": "PiPOverlay.module__hoverOverlay___Wk1Udm",
  "YQ": "PiPOverlay.module__containerInteractionActive___Wk1Udm",
  "YL": "PiPOverlay.module__headerGradient___Wk1Udm",
  "VW": "PiPOverlay.module__headerContent___Wk1Udm",
  "LD": "PiPOverlay.module__headerLeft___Wk1Udm",
  "q3": "PiPOverlay.module__returnToCallButton___Wk1Udm",
  "fs": "PiPOverlay.module__returnToCallIcon___Wk1Udm",
  "Qt": "PiPOverlay.module__returnToCallLabel___Wk1Udm",
  "wY": "PiPOverlay.module__footerGradient___Wk1Udm",
  "z8": "PiPOverlay.module__footerContent___Wk1Udm",
  "PU": "PiPOverlay.module__footerLeft___Wk1Udm",
  "zz": "PiPOverlay.module__streamerName___Wk1Udm",
  "wV": "PiPOverlay.module__footerRight___Wk1Udm",
  "ti": "PiPOverlay.module__spectatorBadge___Wk1Udm",
  "Bh": "PiPOverlay.module__spectatorIcon___Wk1Udm",
  "hP": "PiPOverlay.module__actionButton___Wk1Udm",
  "P4": "PiPOverlay.module__disconnectButton___Wk1Udm",
  "gE": "PiPOverlay.module__actionIcon___Wk1Udm",
};

module.exports = exports;
